import React from 'react'
import classNames from 'classnames'
import useFetchSvg from 'hooks/useFetchSvg'
import { BuildingPlaceholderIcon } from 'assets/icons/BuildingPlaceholderIcon'
import styles from './OverviewV2.module.scss'

interface OverviewV2LogoProps {
  name?: string
  image?: string
}

const OverviewV2Logo = ({ name, image }: OverviewV2LogoProps) => {
  const isSvg = Boolean(image?.endsWith('.svg'))
  const svgBase64 = useFetchSvg(image, isSvg)

  if (!image) {
    return (
      <div className={styles.logoPlaceholder}>
        <BuildingPlaceholderIcon size={24} color='rgba(0, 0, 0, 0.45)' />
      </div>
    )
  }

  return (
    <img
      src={svgBase64 ?? image}
      alt={name || 'Company logo'}
      className={classNames(styles.logo, { [styles.logoWide]: !isSvg })}
    />
  )
}
export default OverviewV2Logo
